import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class CardExamEstablishmentInformationAPI extends ComponentAPI {
    setAddress(value) {
        this.setState({ dsEndereco: value });
    }
    setAddressNumber(value) {
        this.setState({ nrEndereco: value });
    }
    setStateAdress(value) {
        this.setState({ dsEstado: value });
    }
    setCity(value) {
        this.setState({ dsMunicipio: value });
    }
    setLocalidade(value) {
        this.setState({ dsBarrio: value });
    }
    setPostalCode(value) {
        this.setState({ cdCep: value });
    }
    setDdiTelephone(value) {
        this.setState({ nrDdiTelefone: value });
    }
    setDddTelephone(value) {
        this.setState({ nrDddTelefone: value });
    }
    setTelephone(value) {
        this.setState({ nrTelefone: value });
    }
    setName(value) {
        this.setState({ dsRazaoSocial: value });
    }
    setEmail(value) {
        this.setState({ dsEmail: value });
    }
}
export default CardExamEstablishmentInformationAPI;
//# sourceMappingURL=card-exam-establishment-information-api.js.map